import { extendedCast } from '@arcxmoney/arcx-core'
import { handleHttpResponse } from '@arcxmoney/arcx-react'
import { asNumber, asObject } from '@restless/sanitizers'
import { utils } from 'ethers'

export class CoingeckoApi {
  private static API_BASE = 'https://api.coingecko.com/api/v3'

  static async getUsdPrice(erc20Address: string) {
    const lowerCasedAddress = erc20Address.toLowerCase()
    const response = await this.fetch(
      `/simple/token_price/ethereum?contract_addresses=${lowerCasedAddress}&vs_currencies=usd`,
    )
    const result = extendedCast(response, asUsdPrice(lowerCasedAddress))
    return utils.parseEther(result[lowerCasedAddress].usd.toString())
  }

  static async fetch(path: string) {
    const response = await fetch(`${this.API_BASE}${path}`)
    return handleHttpResponse(response)
  }
}

const asUsdPrice = (address: string) =>
  asObject({
    [address]: asObject({
      usd: asNumber,
    }),
  })
